import { render, staticRenderFns } from "./ManageOccurrenceHandling.vue?vue&type=template&id=55ca41e8&scoped=true&"
import script from "./ManageOccurrenceHandling.vue?vue&type=script&lang=js&"
export * from "./ManageOccurrenceHandling.vue?vue&type=script&lang=js&"
import style0 from "./ManageOccurrenceHandling.vue?vue&type=style&index=0&id=55ca41e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca41e8",
  null
  
)

export default component.exports